import React from 'react'
import { Button } from "antd";
import { Link } from "react-router-dom";


const finalFare = () => {
  return (
    <section className="final-fare booking-detail  fareDetail">
   
         <div className="fare-heading-wrap  ">
        <div className="fare-detail-content ">
          <div className="fare">Base fare</div>
          <div className="price">₹3,220 </div>
        </div>

        {/* <div className="fare-detail-content ">
          <div className="fare">Doorstep delivery & pickup</div>
          <div className="price">₹400 </div>
        </div> */}

        <div className="fare-detail-content ">
          <div className="fare">Insurance & GST</div>
          <div className="price">included</div>
        </div>

        <div className="fare-detail-content deposit ">
          <div className="fare">Refundable security deposit</div>
          <div className="price">₹2,500 </div>
        </div>

        <div className="fare-detail-content final-fare">
          <div className="fare total-highlight">Final Fare</div>
          <div className="price total-highlight ">₹6,120 </div>
        </div>

        <div >
          <div className="summary-btn  ">
          <div className="btn-wrap w-100">
          <Link to="">
              <Button type="primary " className="fare-btn-wrap checkout w-100">PROCEED TO PAY ₹6,120 </Button>
            </Link>
        
          </div>
            

       
          </div>
        </div>
      </div>
    </section>
  )
}

export default finalFare